import React from "react";
import styles from "./NavContainer.module.scss";
import { MenuControl } from "./MenuControl";
export const NavContainer = ({ children, isMenuOpen, setMenuOpen, analytics = () => { } }) => {
    return (<>
      <MenuControl isOpen={isMenuOpen} onChange={() => {
            setMenuOpen(!isMenuOpen);
            analytics === null || analytics === void 0 ? void 0 : analytics({
                event: "visitor interaction",
                interactionName: "button click",
                linkText: isMenuOpen
                    ? "close primary navigation bar"
                    : "open primary navigation bar",
                linkUrl: "(no url destination)",
            });
        }}/>

      <div data-testid={"main-menu-contents"} className={`${styles.container} ${isMenuOpen ? styles.fixLeft : ""}`}>
        {children}
      </div>
    </>);
};
